export const LEAGUE_FILTER_KEYS = {
    year: 'year',
    organisation: 'organisation_unit_id',
    onlyPublic: 'is_public',
    isForMe: 'is_for_me',
};

export const MATCH_FILTER_KEYS = {
    competition_year: 'competition_year',
    leagues: 'competition_id',
    home_club: 'home_team_internal_id',
    visitor_club: 'guest_team_internal_id',
    date_from: 'date_from',
    date_to: 'date_to',
    state: 'state',
    committee: 'committee',
    season: 'season',
    round: 'round',
    has_protest_home: 'has_protest_home',
    has_protest_guest: 'has_protest_guest',
    isForMe: 'is_for_me',
};

export const PERSON_FILTER_KEYS = {
    birth_year: 'birth_year',
    gender: 'gender',
    members: 'members[]',
    football_state: `football_state`,
    futsal_state: 'futsal_state',
    roles: 'roles[]',
    owner_club_ids: 'owner_club_ids[]',
    owner_club_internal_ids: 'owner_club_internal_ids[]',
    organisation_units: 'organisation_unit_id[]',
    license_type_referee: 'license_type_referee',
    license_type_delegate: 'license_type_delegate',
    age_from: 'age_from',
    age_to: 'age_to',
    photo: 'photo',
    country_code: 'citizen_of',
    football_membership_unpaid: `football_membership_unpaid`,
    futsal_membership_unpaid: `futsal_membership_unpaid`,
    user_is_email_verified: 'user_is_email_verified',
    organisation_unit_id: 'organisation_unit_id[]',
};
